import alt from '../alt'
import MobileActions from '../actions/MobileActions'

class MobileStore {
  constructor () {
    this.backButton = false

    this.bindListeners({
      showBackButton: MobileActions.SHOW_BACK_BUTTON,
      hideBackButton: MobileActions.HIDE_BACK_BUTTON
    })
  }

  showBackButton () {
    this.backButton = true
  }

  hideBackButton () {
    this.backButton = false
  }
}

module.exports = alt.createStore(MobileStore, 'MobileStore')



// WEBPACK FOOTER //
// ./src/stores/MobileStore.js